import { BudgetMissionInput } from '../../lib/types/models/mission/mission-input'
import { MissionToLecStaffParam } from '../../lib/types/models/mission-to-lec-staff/mission-to-lec-staff-param'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function includeBudgetToLecStaff(input: MissionToLecStaffParam) {
  const { id, userId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.includeBudgetToLecStaff.url, { id, userId }))
    .patch()
}

export function excludeBudgetToLecStaff(input: MissionToLecStaffParam) {
  const { id, userId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.excludeBudgetToLecStaff.url, { id, userId }))
    .patch()
}

export function updateBudgetToLecStaff(input: BudgetMissionInput & MissionToLecStaffParam) {
  const { id, userId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.missions.updateBudgetToLecStaff.url, { id, userId }))
    .patch<never, BudgetMissionInput>(rest)
}
